import { useMemo } from 'react';

import type { ShareChannel, ShareConfig } from '../shared/types';

import { useFacebookMessengerAvailable } from './channels/facebookMessenger';
import { useInstagramAvailable } from './channels/instagram';
import { useInstagramStoriesAvailable } from './channels/instagramStories';
import { useLineAvailable } from './channels/line';
import { useMobileNativeShareAvailable } from './channels/mobileNativeShare';
import { useSmsAvailable } from './channels/sms';
import { useTiktokAvailable } from './channels/tiktok';
import { useVkAvailable } from './channels/vk';

export function useShareChannelsAvailability(config: ShareConfig): Readonly<Record<ShareChannel, boolean>> {
	const vk = useVkAvailable();
	const line = useLineAvailable();
	const facebookMessenger = useFacebookMessengerAvailable();
	const instagram = useInstagramAvailable();
	const instagramStories = useInstagramStoriesAvailable(config);
	const tiktok = useTiktokAvailable(config);
	const sms = useSmsAvailable();
	const mobileNativeShare = useMobileNativeShareAvailable();

	return useMemo(
		() => ({
			facebook: true,
			twitter: true,
			email: true,
			copy: true,
			whatsapp: true,
			nextdoor: true,
			qrcode: true,
			flyer: true,
			reddit: true,
			instagram,
			instagramStories,
			tiktok,
			vk,
			line,
			facebookMessenger,
			sms,
			mobileNativeShare,
		}),
		[vk, line, facebookMessenger, instagram, instagramStories, tiktok, sms, mobileNativeShare],
	);
}
